var id = {
  "Add Upsell.com to your ": "Tambahkan Upsell.com ke ",
  "All time": "Sepanjang waktu",
  "and select": "dan pilih",
  "button": "",
  "Cart drawer page": "Halaman Laci keranjang",
  "Cart page": "Halaman Keranjang",
  "Check status": "Periksa status",
  "Checkout page": "Halaman Checkout",
  "Click": "Klik",
  "Click on": "Klik",
  "Click the": "Klik tombol",
  "Custom slot": "Slot Kustom",
  "Custom slots": "Slot Kustom",
  "Custom Slots": "Slot Kustom",
  "contact support.": "hubungi dukungan.",
  "from the right sidebar": "dari bilah sisi kanan",
  "Go to your Cart drawer page": "Buka halaman Laci keranjang Anda",
  "Go to your Cart page": "Buka halaman Keranjang Anda",
  "Go to your Checkout page": "Buka halaman Checkout Anda",
  "Go to your Order status page": "Buka halaman Status pesanan Anda",
  "Go to your Post purchase page": "Buka halaman Pasca pembelian Anda",
  "Go to your Product page": "Buka halaman Produk Anda",
  "Go to your Thank you page": "Buka halaman Terima kasih Anda",
  "items": "item",
  "in the left sidebar": "di bilah sisi kiri",
  "Last 12 months": "12 bulan terakhir",
  "Last 30 days": "30 hari terakhir",
  "Last 365 days": "365 hari terakhir",
  "Last 7 days": "7 hari terakhir",
  "Last 90 days": "90 hari terakhir",
  "Last month": "Bulan lalu",
  "Last year": "Tahun lalu",
  "Make sure": "Pastikan",
  "Need assistance? Contact our support team for help.": "Butuh bantuan? Hubungi tim dukungan kami.",
  "Order status page": "Halaman Status pesanan",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Aplikasi kami sedang mengalami sedikit perbaikan untuk meningkatkan pengalaman Anda.",
  "Post purchase page": "Halaman Pasca pembelian",
  "Product page": "Halaman Produk",
  "Save": "Simpan",
  "Scroll to the bottom and select": "Gulir ke bawah dan pilih",
  "Select": "Pilih",
  "Success. Please continue.": "Berhasil. Silakan lanjutkan.",
  "Thank you page": "Halaman Terima kasih",
  "The Upsell.com team.": "Tim Upsell.com.",
  "The Upsell.com widget is not placed on ": "Widget Upsell.com tidak ditempatkan di ",
  ". Please follow the steps above or ": ". Silakan ikuti langkah-langkah di atas atau ",
  "Today": "Hari ini",
  "toggle is on": "tombol aktif",
  "Total": "Total",
  "under": "di bawah",
  "We apologize for any inconvenience caused,": "Kami mohon maaf atas ketidaknyamanan yang ditimbulkan,",
  "We apologize for any inconvenience caused.": "Kami mohon maaf atas ketidaknyamanan yang ditimbulkan.",
  "We'll be done in a few minutes!": "Kami akan selesai dalam beberapa menit!",
  "We're improving our services!": "Kami meningkatkan layanan kami!",
  "Widget already added": "Widget sudah ditambahkan",
  "Yesterday": "Kemarin",
  "You placed the widget on the ": "Anda menempatkan widget di ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", tetapi Anda tidak menyimpannya di editor Shopify. Silakan kembali ke ",
  " and save the changes.": " dan simpan perubahan."
};

export { id as default };
//# sourceMappingURL=id.json.js.map
